/**
 * zone-configuration-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { SubjectContextType } from "../../../subjects/subject-context-type";
import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * An {@link AlgorithmDescriptor} is a simple description of the name and {@link
 * SubjectContextType} of an algorithm.
 */
export interface AlgorithmDescriptor {
    name : string;
    displayName : string;
    description? : string;
    type : SubjectContextType;
    supportsIntake : boolean;
    useCustomFlow: string | undefined; // e.g. "first_check_v1"
}

/**
 * The {@link ZoneConfigurationResponse} identifies configuration details about
 * the zone the current session is authorized through. This includes which
 * algorithms and special behaviors are available.
 */
@validateFor(MessageTag.RSP_CFG_ZONE)
export class ZoneConfigurationResponse extends IncomingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.RSP_CFG_ZONE;

    @validateAs({array: "object"}) // TODO: better validation
    public algorithms : AlgorithmDescriptor[];

    @validateAs("string")
    public title : string;

    @validateAs("boolean")
    public supportRequestEnabled : boolean;

    @validateAs({array: "string"})
    public supportAlgorithms : string[];

    @validateAs("boolean")
    public referrals : boolean;

    @validateAs("string", true, "«no referral targets»")
		public referralOrg : string;
		
		@validateAs({array: "object"})
		public availableCountryCodes : Array<{countryCode : string, id : number}>;

		@validateAs({array: "object"})
		public availableLanguageCodes : Array<{languageCode : string, id : number}>;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/metadata/zone-configuration-response.ts